<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card>
    <p class="font-weight-bolder">Busiest Day</p>

    <section class="call-stats__items" v-if="!loading">
      <!--      <statistic-card-with-line-chart></statistic-card-with-line-chart>-->
      <b-form-select v-model="activeChart" class="mb-2" :class="{'disabled': loading}">
        <b-form-select-option value="future">Busiest Day (Future)</b-form-select-option>
        <b-form-select-option value="past">Busiest Day (Past)</b-form-select-option>
      </b-form-select>

      <p v-if="filters.prisonId">Click chart bar to show prison booking slot breakdown</p>

      <section>
        <apex-chart :key="1" class="mx-auto" v-if="activeChart === 'past'"
                    @data-clicked="mangeChartClick($event)"
                    :title="'Busiest Call day for completed calls'"
                    y-title="Number of calls" x-title="Weekdays" :series="[chart.past_days.series]"></apex-chart>

        <apex-chart :key="2" class="mx-auto" v-if="activeChart === 'future'"
                    @data-clicked="mangeChartClick($event)"
                    :title="'Busiest Call day for approved calls '" y-title="Number of calls"
                    x-title="Weekdays" :series="[chart.future_days.series]"></apex-chart>

        <apex-chart :key="3" class="mx-auto day-chart mt-4" v-if="chart.day_slots && !loadingDay && filters.prisonId"
                    :title="'Total Bookings for ' + activeDay + ' slots over date range '" y-title="Number of bookings"
                    x-title="Booking Slots" :series="[chart.day_slots.series]"></apex-chart>
      </section>
    </section>

    <section v-else class="d-flex justify-center pb-6 pt-8 flex-wrap">
      <p class="full-width d-flex justify-content-center"><b-spinner variant="primary"></b-spinner>
        <span class="d-inline-block ml-2">Getting Stats...</span>
      </p>
    </section>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
  import Vue from 'vue';
  import { mapState } from 'vuex';
  //  import StatisticCardWithLineChart from '@core/components/statistics-cards/StatisticCardWithLineChart.vue'
  import BiStatsService from '../../../services/BiStatsService';
  import ApexChart from '../ApexChart.vue';
  import HelperService from '../../../services/HelperService';

  export default {
    components: {
      // StatisticCardWithLineChart,
      ApexChart,
    },
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        helperService: new HelperService(),
        loading: true,
        stats: null,
        slotStats: null,
        activeChart: 'past',
        activeDay: '',
        chart: {
          past_days: {
            series: {
              name: '',
              data: [],
            },
          },
          future_days: {
            series: {
              name: '',
              data: [],
            },
          },
          day_slots: null,
        },
        loadingDay: false,
      };
    },
    computed: {
      ...mapState({
        compareMode: state => state.stats.compareMode,
      }),
    },
    watch: {
      filters: {
        handler() {
          this.getBusiestDayStats();
        },
        deep: true,
      },
    },
    mounted() {
      this.getBusiestDayStats();
    },
    methods: {
      getBusiestDayStats() {
        this.loading = true;

        BiStatsService.getBusiestDay(this.filters).then(res => {
          this.stats = res.data;
          this.setBusiestChartData('Number of calls', 'past_days');
          this.setBusiestChartData('Number of calls', 'future_days');
        }).catch(err => {
          console.log('could not get busiest day', err);
          this.$toast.error('Could not get busiest day stats, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      setBusiestChartData(name, chartType) {
        const weekdays = this.helperService.getWeekdays();
        this.chart[chartType].series.name = name;

        const dayData = this.stats[chartType];
        this.chart[chartType].series.data = []; // reset data

        weekdays.forEach(day => {
          this.chart[chartType].series.data.push({
            x: this.$options.filters.capEachWord(day), // capEachWord
            y: dayData[day],
          });
        });
      },
      mangeChartClick(data) {
        const activeChart = this.chart[`${this.activeChart}_days`];
        const series = activeChart.series.data[data.dataPointIndex];

        if (this.filters.prisonId) {
          this.getSlotDayData(series.x);
        }
      },
      getSlotDayData(day) {
        this.setActiveDay(day);

        if (!this.slotStats) { // get the stats if not already received
          this.getBookingSlotStats();
        } else {
          this.setDaySlotData(this.activeDay);
        }
      },
      getBookingSlotStats() {
        return BiStatsService.getBookingSlotStats(this.filters).then(res => {
          this.slotStats = res.data.booking_slots;
          this.setDaySlotData(this.activeDay);
        }).catch(err => {
          console.log('could not get call stats', err);
          this.$toast.error('Could not get booking slot stats, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      setActiveDay(day) {
        this.activeDay = day.toLowerCase();
      },
      setDaySlotData(day) {
        this.loadingDay = true;
        this.setActiveDay(day);

        this.daySlotData = this.slotStats.filter(slot => slot.weekday.toLowerCase() === day.toLowerCase());

        this.chart.day_slots = this.setDayChartDataSimple();
        this.scrollDayChartIntoView();
      },
      setDayChartDataSimple() {
        const chart = {
          series: {
            name: '',
            data: [],
          },
        };

        const dayData = this.daySlotData;

        dayData.forEach(slot => {
          chart.series.data.push({
            x: slot.name,
            y: slot.bookings,
          })
        });

        return chart;
      },
      scrollDayChartIntoView() {
        Vue.nextTick(() => { // delay to refresh the ui
          this.loadingDay = false;

          Vue.nextTick(() => {
            const chart = document.querySelector('.day-chart');

            if (chart) {
              chart.scrollIntoView(true);
            }
          });
        });
      },
    },
  };
</script>
